import type { StatusBadgeTone } from '@/shared/ui/components/basic/StatusBadge';

type SearchStatus = 'pending' | 'running' | 'completed' | 'failed';

const STATUS_TONE_MAP: Record<SearchStatus, StatusBadgeTone> = {
  pending: 'warning',
  running: 'info',
  completed: 'success',
  failed: 'error',
};

/**
 * Maps a partnership search status to its canonical StatusBadge tone.
 *
 * @param status - The search status from the API.
 * @returns The semantic tone for {@link StatusBadge}.
 */
export function searchStatusToTone(status: SearchStatus): StatusBadgeTone {
  return STATUS_TONE_MAP[status] ?? 'neutral';
}
